import Augment from './_Augment';

var METADATA_CLASS = 'edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO';

/**
 * Creates a new "Field is required" aspect.
 * @param {Object} expressionLanguage
 * @returns {Object}
 */
function create(expressionLanguage) {
    function getAllRules(compilationContext, node, nodeMetadata, ancestorChain) {
        return Augment.collectRules(compilationContext, node, nodeMetadata, ancestorChain, METADATA_CLASS);
    }

    function compileRule(compilationContext, rule) {
        var visibilityExpr = compilationContext.compile(rule.data.expression);
        var messageExpr = compilationContext.compile(rule.data.message);

        return {
            'shouldApply': rule.shouldApply,
            'status': visibilityExpr,
            'message': messageExpr
        };
    }

    function combineRules(rules) {
        return {
            'visible': function visible(v, pv, ctx) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = rules[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var rule = _step.value;

                        if (rule.shouldApply() && rule.status(v, pv, ctx) === 'NOT_SET') {
                            return false;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                return true;
            },
            'required': function required(v, pv, ctx) {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = rules[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var rule = _step2.value;

                        if (rule.shouldApply() && rule.status(v, pv, ctx) === 'REQUIRED') {
                            return true;
                        }
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                return false;
            },
            'requirednessMessages': function requirednessMessages(v, pv, ctx) {
                var messages = [];
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = rules[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var rule = _step3.value;

                        if (rule.shouldApply() && rule.status(v, pv, ctx) === 'REQUIRED') {
                            messages.push(rule.message(v, pv, ctx));
                        }
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }

                return messages;
            }
        };
    }

    return {
        'getAspectProperties': function getAspectProperties(currentViewModelNode, currentMetadataNode, ancestorChain) {
            var compilationContext = expressionLanguage.getCompilationContext(currentMetadataNode.xCenter);
            var rules = getAllRules(compilationContext, currentViewModelNode, currentMetadataNode, ancestorChain);
            var compiledRules = new Array(rules.length);
            for (var i = 0; i < rules.length; i++) {
                compiledRules[i] = compileRule(compilationContext, rules[i]);
            }

            var descriptor = combineRules(compiledRules);
            return {
                'visible': {
                    'get': function get() {
                        return descriptor.visible(currentViewModelNode, ancestorChain.parent, currentViewModelNode.aspects.context);
                    }
                },
                'required': {
                    'get': function get() {
                        return descriptor.required(currentViewModelNode, ancestorChain.parent, currentViewModelNode.aspects.context);
                    }
                },
                '_requirednessMessages': {
                    'get': function get() {
                        return descriptor.requirednessMessages(currentViewModelNode, ancestorChain.parent, currentViewModelNode.aspects.context);
                    }
                }
            };
        }
    };
}

export default {
    create: create
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-viewmodel-js/aspects/Requiredness.js
// module id = 940
// module chunks = 0